import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import eventBus         from 'EventBus.js';
import nameTemplate from 'properties/main/size.ejs';
import listService      from 'ListService.js';
import util from '../../../service/util/Util';
import TextUtil from 'util/TextUtil.js';
import undoService from 'UndoService';
import constants from 'Constants';

const MIN_SIZE = 100;

class MainSizeView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[name=formHeight]' : 'updateFormSize',
            'change input[name=formWidth]' : 'updateFormSize',
            'change #sizePreset' : 'updateSizeAttributes',
            'change #unit' : 'updateAttributes',
            'change input[name=dpi]': 'updateDPI',
            'keydown input[name=formWidth],input[name=formHeight]': 'tab',
            'keydown #unit': 'tabSelect'
        };

        if(!this.model.get('unit')){
            this.model.set('unit','pixel',{silent:true});
        }

        this.listenTo(eventBus, 'formPropertiesChanged', this.render);
        return this;
    }

    tabSelect(ev){
        if (ev.keyCode === 13 || ev.keyCode === 9) {
            TextUtil.focusNextElement(ev);
        }
    }

    tab(ev){
        if (ev.keyCode === 13 || ev.keyCode === 9) {
            $(ev.currentTarget).trigger('change');
        }
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumeric(ev);
    }

    updateAttributes(evt){
        evt.preventDefault();

        const propName = evt.currentTarget.name.trim();
        const propVal  = evt.currentTarget.value.trim();
        let oldVal = this.model.get(propName); 

        if (propVal.toString() !== oldVal.toString()) {
            this.model.set( propName, propVal );

            if(!TextUtil.isIExplorer() && !TextUtil.isEdge()){
                if(propName==='unit'){
                    $('#unit').focus();
                }
            }

            this.render();

            undoService.add({
                undo: () => {
                    this.model.set(propName, oldVal);
                     
                    this.render();
                },
                redo:() => {
                    this.model.set(propName, propVal);
                     
                    this.render();            
                }
            }, constants.UNDO_PROP_CHANGE);
        } 

    }

    updateSizeAttributes(evt){
        evt.preventDefault();

        const propName = evt.currentTarget.name.trim();
        const propVal  = evt.currentTarget.value.trim();
        let oldVal = this.model.get(propName);
        const oldFormWidth = this.model.get('formWidth');
        const oldFormHeight = this.model.get('formHeight')
        let formWidth, formHeight;

        this.model.set( propName, propVal );
        if(propVal.toLowerCase() !== 'custom') {
            
            this.setPrefixedSize(propVal.toLowerCase());

            formWidth = this.model.get('formWidth');
            formHeight = this.model.get('formHeight')

            let maximumFormSize = this.getMaximumFormSize(formWidth,formHeight);
            formHeight = Math.round(maximumFormSize.height);
            formWidth = Math.round(maximumFormSize.width);
            
            this.render(); 
            eventBus.trigger('formSizeSet', maximumFormSize.width, maximumFormSize.height); 
        }


        if (propVal.toString() !== oldVal.toString()) {

            if(!TextUtil.isIExplorer() && !TextUtil.isEdge()){
                if(propName==='sizePreset'){
                    $('#sizePreset').focus();
                }
            }

            undoService.add({
                undo: () => {
                    this.model.set(propName, oldVal);                     
                    eventBus.trigger('formSizeSet', oldFormWidth, oldFormHeight);  
                    this.render();
                },
                redo:() => {
                    this.model.set(propName, propVal);                     
                    eventBus.trigger('formSizeSet', formWidth, formHeight);    
                    this.render();          
                }
            }, constants.UNDO_PROP_CHANGE);
        }        

    }

    setPrefixedSize(option) {
        switch (option){
            case 'medium':
                this.model.set('formHeight','400',{silent:true});
                this.model.set('formWidth','500',{silent:true});
                this.model.set('unit','pixel',{silent:true});
                break;
            case 'large':
                this.model.set('formHeight','800',{silent:true});
                this.model.set('formWidth','800',{silent:true});
                this.model.set('unit','pixel',{silent:true});
                break;
            case 'small':
                this.model.set('formHeight','300',{silent:true});
                this.model.set('formWidth','400',{silent:true});
                this.model.set('unit','pixel',{silent:true});
                break;
            case 'letter':
                this.model.set('formHeight','792',{silent:true});
                this.model.set('formWidth','612',{silent:true});
                this.model.set('unit','inch',{silent:true});
                break;
            case 'legal':
                this.model.set('formHeight','1008',{silent:true});
                this.model.set('formWidth','612',{silent:true});
                this.model.set('unit','inch',{silent:true});
                break;
            case 'executive':
                this.model.set('formHeight','756',{silent:true});
                this.model.set('formWidth','522',{silent:true});
                this.model.set('unit','inch',{silent:true});
                break;
            case 'a4':
                this.model.set('formHeight','842',{silent:true});
                this.model.set('formWidth','595',{silent:true});
                this.model.set('unit','mm',{silent:true});
                break;
            case 'a5':
                this.model.set('formHeight','595',{silent:true});
                this.model.set('formWidth','420',{silent:true});
                this.model.set('unit','mm',{silent:true});
                break;
            case 'b4':
                this.model.set('formHeight','1001',{silent:true});
                this.model.set('formWidth','709',{silent:true});
                this.model.set('unit','mm',{silent:true});
                break;
            case 'b5':
                this.model.set('formHeight','709',{silent:true});
                this.model.set('formWidth','499',{silent:true});
                this.model.set('unit','mm',{silent:true});
                break;
            default: break;
        }
    }

    updateFormSize(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let oldVal = this.model.get(propName);

        if(!TextUtil.isDecimalOrNumeric(propVal)){
            propVal=this.model.get(propName);
            $('input[name="'+propName+'"]').val(propVal);
        }

        if((!Number(propVal) || propVal === '' || Number(propVal) < 100) && (this.model.get('unit')==='pixel')){
            propVal = MIN_SIZE;
            if(propName === 'formWidth'){
               $('input[name=formWidth]').val(MIN_SIZE);
            }else{
               $('input[name=formHeight]').val(MIN_SIZE);
            }
        }
        let newWidth, newHeight;
        
        let convertValue = (newValue) => {
            return TextUtil.convertFromUnitToPixel(
                        parseFloat(newValue),
                        this.model.get('unit'),
                        this.model.get('dpi'));
        }  
        
        let getNewValues = (field, valueConverted) => {
            switch (field){
                case 'formHeight': 
                    newHeight = valueConverted;
                    newWidth = this.model.get('formWidth');
                break;
                case 'formWidth': 
                    newWidth = valueConverted;
                    newHeight = this.model.get('formHeight');
                break;
                default:
                    newHeight = this.model.get('formHeight');
                    newWidth = this.model.get('formWidth');
                break;
            }

            return { newWidth, newHeight };
        } 
        
        let setNewValues = (field, maxFormSize) => {
            switch (field){
                case 'formHeight':
                    this.model.set( 'formHeight', maxFormSize.height);
                    eventBus.trigger('formHeightSet', maxFormSize.height);
                break;
                case 'formWidth':
                    this.model.set( 'formWidth', maxFormSize.width);
                    eventBus.trigger('formWidthSet', maxFormSize.width);
                break;
                default:
                    this.model.set( 'formHeight', maxFormSize.height);
                    eventBus.trigger('formHeightSet', maxFormSize.height);
                    this.model.set( 'formWidth', maxFormSize.width);
                    eventBus.trigger('formWidthSet', maximmaxFormSizeumFormSize.width);
                break;
            }
        }

        let newSizes = getNewValues(propName, convertValue(propVal));
        let maximumFormSize = this.getMaximumFormSize(newSizes.newWidth, newSizes.newHeight);

        maximumFormSize.height = Math.round(maximumFormSize.height);
        maximumFormSize.width = Math.round(maximumFormSize.width);

        setNewValues(propName, maximumFormSize); 

        if (propVal.toString() !== oldVal.toString()) { 
            undoService.add({
                undo: () => {
                    this.model.set(propName, oldVal);
                    let newSizes = getNewValues(propName, convertValue(oldVal));
                    let maximumFormSize = this.getMaximumFormSize(newSizes.newWidth, newSizes.newHeight);
            
                    maximumFormSize.height = Math.round(maximumFormSize.height);
                    maximumFormSize.width = Math.round(maximumFormSize.width);
            
                    setNewValues(propName, maximumFormSize);
                    eventBus.trigger('formPropertiesChanged');   
                },
                redo:() => {
                    this.model.set(propName, propVal); 
                                
                    let newSizes = getNewValues(propName, convertValue(propVal));
                    let maximumFormSize = this.getMaximumFormSize(newSizes.newWidth, newSizes.newHeight);
            
                    maximumFormSize.height = Math.round(maximumFormSize.height);
                    maximumFormSize.width = Math.round(maximumFormSize.width);
            
                    setNewValues(propName, maximumFormSize);   
                    eventBus.trigger('formPropertiesChanged');                 
                }
            }, constants.UNDO_PROP_CHANGE); 
        }

        TextUtil.focusNextElement(ev);

    }

    getMaximumFormSize(newWidth,newHeight){
        let width = newWidth, height = newHeight;
        let allControls = listService.getAllControlsByPage().reduce((accum, item) => {
           return [...accum,...item.controls.toArray()];
        }, []);

        console.log('AllControls',allControls);

        if (allControls.length > 0) {
            let evaluateCurrentSize = (p1, p2, p3, p4) => {
                return (p1 + util.extractNum(p2)) > (p3 + util.extractNum(p4)); 
            }; 

            let maxSizes = allControls.reduce((accum, item)=> {
                console.log("Accum", accum);
                console.log("Item", item);

                let factoryKey = item.model.get('factoryKey'); 
                if (factoryKey !== 'control_timer' && factoryKey !== 'control_sound') {
                    if ($.isEmptyObject(accum)) {
                        return {controlMaxTop: item, controlMaxLeft: item};
                    }

                    if (evaluateCurrentSize(item.model.get('top'), item.model.get('height'), accum.controlMaxTop.model.get('top'), accum.controlMaxTop.model.get('height'))) {
                        accum.controlMaxTop = item;
                    }

                    if (evaluateCurrentSize(item.model.get('left'), item.model.get('width'), accum.controlMaxLeft.model.get('left'), accum.controlMaxLeft.model.get('width'))) {
                        accum.controlMaxLeft = item;
                    }
                }

                return accum;
            }, {});

            console.log("These are the max sizes", maxSizes);

            let maxWidth = 0;
            let maxHeight = 0;

            if (!$.isEmptyObject(maxSizes)) {
                maxWidth = parseFloat(maxSizes.controlMaxLeft.model.get('left')) + parseFloat(maxSizes.controlMaxLeft.model.get('width'));
                maxHeight = parseFloat(maxSizes.controlMaxTop.model.get('top')) + parseFloat(maxSizes.controlMaxTop.model.get('height'));
            } 
          
            // Send to the event Bus
            // Get Maximum left and Top and comparing to the maximum width and height that it could have. 

            console.log("New width", newWidth);
            console.log("New Height", newHeight);

            console.log("Max width", maxWidth);
            console.log("Max Height", maxHeight); 
            maxWidth = isNaN(maxWidth) ? newWidth : maxWidth;
            maxHeight = isNaN(maxHeight) ? newHeight : maxHeight;

            width = newWidth > maxWidth ? newWidth : maxWidth;
            height = newHeight > maxHeight ? newHeight : maxHeight;

            console.log("Final width", width);
            console.log("Final height", height);
        } 

        return {
            width, height
        };
    }

    updateDPI(evt){
        evt.preventDefault();
        const propName = evt.currentTarget.name;
        let propVal  = Number(evt.currentTarget.value);
        if(isNaN(propVal) || !Number(propVal) || Number(propVal) < 0 || Number(propVal) % 1 !== 0){
           propVal = '';
           $('input[name=dpi]').val('');
        }
        // Obtaining the values already converted.
        const currentWidthDisplayed=$('input[name=formWidth]').val();
        const currentHeightDisplayed=$('input[name=formHeight]').val();

        const newWidth=TextUtil.convertFromUnitToPixel(
            currentWidthDisplayed,
            this.model.get('unit'),
            this.model.get('dpi'));

        const newHeight=TextUtil.convertFromUnitToPixel(
            currentHeightDisplayed,
            this.model.get('unit'),
            this.model.get('dpi'));

        this.model.set( propName, propVal );

        this.model.set( 'formWidth', Math.round(newWidth) );
        this.model.set( 'formHeight', Math.round(newHeight) );

        this.render();
    }

    render() {
        this.$el.empty();  

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.model.get('sizePreset')) {
            $('#sizePreset').find("option[value='"+this.model.get('sizePreset')+"']").attr('selected', true);
        }

        if(this.model.get('unit')) {
            $('#unit').find("option[value='"+this.model.get('unit')+"']").attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }

    updateForm() {
        //set selected index to model value
        if(this.model.get('sizePreset')) {
            $('#sizePreset').find("option[value='"+this.model.get('sizePreset')+"']").attr('selected', true);
        }

        if(this.model.get('unit')) {
            $('#unit').find("option[value='"+this.model.get('unit')+"']").attr('selected', true);
        }
    }


}

export default MainSizeView;
